import { useModules } from '@entities/common/index.ts';
import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';
import { useModuleByCodeParam } from '@shared/hooks/use-module-by-code-param.ts';
import { API } from '@src/api/index.ts';

export const usePartitionsQuery = (codeFormParams?: string) => {
  const { moduleId } = useModuleByCodeParam();
  const { moduleByCode } = useModules();

  const moduleFormParams = useMemo(() => {
    return moduleByCode(codeFormParams);
  }, [codeFormParams, moduleByCode]);

  const searchId = useMemo(() => {
    return moduleFormParams?.id ?? moduleId;
  }, [moduleId, moduleFormParams]);

  return useQuery({
    queryFn: async () => await API.common.getPartitions({ module: searchId }),
    queryKey: ['partitions', searchId],
    initialData: [],
    enabled: typeof searchId !== 'undefined',
  });
};
